import { z } from 'zod';
import { zCommentableFields, zTotalCommentsFields } from './comment.js';
import { expectType, zDocument, zFeedbackFields } from './model.js';
import { zTotalReportsFields } from './report.js';
import { zAuthorFields, zFullAuthorFields } from './user.js';
import { zTotalEngagementFields } from './postView.js';
import { reverseKeys } from './util/reverseKeys.js';
export const PostTypesLookup = {
    none: 'None',
    basic: 'Basic',
    event: 'Event',
    poll: 'Poll',
    communityQuestion: 'Community Question',
    businessPost: 'Business Post',
    businessCheckIn: 'Business CheckIn',
    marketplaceItem: 'Marketplace Item'
};
export const FeedFilterLookup = {
    all: 'All',
    basic: 'Post',
    event: 'Event',
    communityQuestion: 'Community Question',
    businessPost: 'Business Post',
    businessCheckIn: 'Business CheckIn',
    marketplaceItem: 'Marketplace Item',
    poll: 'Poll'
};
export const PromotionLevelLookup = {
    low: 'Low',
    medium: 'Medium',
    high: 'High'
};
export const PostTypesEnum = z.nativeEnum(reverseKeys(PostTypesLookup));
export const PromotionLevelEnum = z.nativeEnum(reverseKeys(PromotionLevelLookup));
const _zLinkPreview = z.object({
    url: z.string(),
    title: z.string(),
    image: z.string().optional(),
    description: z.string().optional()
});
const _zPostBase = zDocument.extend({
    type: z.literal('post'),
    title: z.string(),
    topic: z.string(),
    contentType: z.string(),
    contents: z.string(),
    linkPreview: _zLinkPreview.nullable(),
    draft: z.boolean(),
    images: z.array(z.string()),
    postType: PostTypesEnum,
    promotionLevel: PromotionLevelEnum.nullable(),
    promotionEndDate: z.string().datetime().nullable().or(z.literal('')),
    promotionStartDate: z.string().datetime().nullable().or(z.literal('')),
    businessId: z.string(),
    interactionDate: z.string().datetime().or(z.literal('')),
    guid: z.string()
});
export const zPostBase = _zPostBase.merge(zAuthorFields).merge(zCommentableFields);
expectType({});
expectType({});
const FullFields = z.object({
    fullAuthor: zFullAuthorFields.shape.fullAuthor,
    feedback: zFeedbackFields.shape.feedback,
    totalComments: zTotalCommentsFields.shape.totalComments,
    totalReports: zTotalReportsFields.shape.totalReports,
    engagement: zTotalEngagementFields.shape.engagement
});
export const zFullPostBase = zPostBase.merge(FullFields);
expectType({});
expectType({});
export const EmptyPostBase = {
    _id: '',
    _rev: '',
    created: '',
    updated: '',
    interactionDate: '',
    type: 'post',
    title: '',
    topic: '',
    author: '',
    images: [],
    contentType: 'text',
    contents: '',
    displayComments: true,
    closedForComments: false,
    draft: true,
    postType: 'none',
    promotionLevel: null,
    promotionEndDate: null,
    promotionStartDate: null,
    linkPreview: null,
    businessId: '',
    guid: ''
};
export const EmptyFeedFilter = {
    filterBy: 'all',
    topic: ''
};
export function getReplyTitle(postType) {
    switch (postType) {
        case 'marketplaceItem':
            return 'message';
        case 'communityQuestion':
            return 'answer';
        default:
            return 'comment';
    }
}
export function getLoadingMessage(postType) {
    switch (postType) {
        case 'marketplaceItem':
            return 'Messaging...';
        case 'communityQuestion':
            return 'Answering...';
        default:
            return 'Commenting...';
    }
}
